import { TFunction } from 'i18next'
import z from 'zod'

import { GetClientsDashboardResponse } from '@/api/clients/get-clients-dashboard'

export const AppUserFilterEnum = z.enum(['yes', 'no'])
export type AppUserFilter = z.infer<typeof AppUserFilterEnum>

export const PMSConnectedBuildingStatusEnum = z.enum(['all', 'future', 'current', 'notice', 'past'])
export type PMSConnectedBuildingStatus = z.infer<typeof PMSConnectedBuildingStatusEnum>

export const NonPMSConnectedBuildingStatusEnum = z.enum(['active', 'pending', 'archived'])
export type NonPMSConnectedBuildingStatus = z.infer<typeof NonPMSConnectedBuildingStatusEnum>

export const ClientFilterStatusEnum = z.union([
  PMSConnectedBuildingStatusEnum,
  NonPMSConnectedBuildingStatusEnum,
])

export type ClientFilterStatus = z.infer<typeof ClientFilterStatusEnum>

export type ClientFilterTabsProps = {
  data: GetClientsDashboardResponse | undefined
  isPMSConnectedBuilding?: boolean
  t: TFunction<['clients', 'common']>
}
